/**
 * Misma lógica que `normalizeEtiquetaSlug` en el backend (slug estable por nombre de instrumento).
 */
export function etiquetaSlugDesdeNombre(nombre) {
  if (!nombre?.trim()) return '';
  const s = nombre
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/º|ª/g, (c) => (c === 'º' ? 'o' : 'a'))
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  return s || '';
}

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function slugMatchesTarget(pageSlug, targetSlug) {
  if (!pageSlug || !targetSlug) return false;
  if (pageSlug === targetSlug) return true;
  // Legado / cabeceras: páginas "bajo" cuentan al filtrar por tuba
  if (targetSlug === 'tuba' && pageSlug === 'bajo') return true;
  const targetBase = targetSlug.replace(/_\d+$/, '');
  if (targetBase !== targetSlug && pageSlug === targetBase) return true;
  if (targetBase !== targetSlug && targetBase === 'tuba' && pageSlug === 'bajo') return true;
  if (targetSlug === targetBase && new RegExp(`^${escapeRegExp(targetSlug)}_\\d+$`).test(pageSlug)) {
    return true;
  }
  return false;
}

function entryMatchesInstrumentoTarget(entry, targetSlug) {
  if (!entry || !targetSlug) return false;
  if (slugMatchesTarget(entry.slug, targetSlug)) return true;
  const byName = etiquetaSlugDesdeNombre(entry.nombre || '');
  if (byName && slugMatchesTarget(byName, targetSlug)) return true;
  return false;
}

/**
 * Misma regla que `pageInstrumentMatchesPartichellasTarget` en el backend.
 */
export function paginaInstrumentoCoincideFiltro(instrumentosVoces, targetSlugRaw) {
  const targetSlug = etiquetaSlugDesdeNombre(targetSlugRaw);
  if (!targetSlug) return false;
  const iv = Array.isArray(instrumentosVoces) ? instrumentosVoces : [];
  return iv.some((entry) => entryMatchesInstrumentoTarget(entry, targetSlug));
}
